<template>
  <div class="base-text-comp app-flex-mid-center">
    <div class="text-wrap">
      <div :class="['text-shadow', type == 'normal' ? 'normal-text-shadow' : 'large-text-shadow']" :style="{ color: shadowColor }">{{ title }}</div>
      <div class="title-text" :style="{ color: color }">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseText',
  props: {
    // 展示的题目
    title: String,
    // type 类型，normal 为平常的，large：为大的尺寸【一般用于封面】
    type: {
      type: String,
      default: 'normal'
    },
    // 字体的主颜色
    color: {
      type: String,
      default: '#000'
    },
    // 字体阴影
    shadowColor: {
      type: String,
      default: '#edeff1'
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text-comp {
  .text-wrap {
    user-select: none;
    position: relative;
    .text-shadow {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      line-height: 95px;
    }
    .normal-text-shadow {
      font-size: 74px;
    }
    .large-text-shadow {
      font-size: 114px;
    }
    .title-text {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      font-size: 60px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      line-height: 95px;
      text-align: center;
    }
  }
}
</style>
